export function isNavigatorShareSupported() {
  return typeof window !== 'undefined' && Boolean(window.navigator.share);
}
